import {AlertType} from "../../interfaces/IAlert"; import {AlertType} from
"../interfaces/IAlert";
<template>
  <v-container class="login-container" fill-height fluid>
    <div class="login-background">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 1903 556"
      >
        <path
          class="svg-banner-shape"
          d="M753.1,434.2c110.6,63.7,277.7,70.6,373.4,15.4L1905,0v555.9H0V0.2L753.1,434.2z"
        ></path>
      </svg>
    </div>
    <v-row align="center" justify="center" style="z-index: 10">
      <v-col cols="11" sm="7" md="5" lg="4" xl="3">
        <div class="logo text-center mb-12 font-weight-medium">
          <img
            :src="
              '/admin/assets/img/logos/' +
              'homelogo.png'
            "
          />
        </div>
        <v-card>
          <v-card-title class="display-1 justify-center font-weight-medium">{{
            $t('login.welcome')
          }}</v-card-title>
          <v-card-text>
            <template v-if="!cookiesEnabled">
              <p class="mb-0">
                Su navegador tiene los cookies desactivados. Esto puede ser
                porque está utilizando el modo incógnito. QueResto necesita que
                los cookies esten activados para funcionar. <br />Por favor,
                verifique que no esté en modo incógnito y actualice la página.
              </p>
            </template>
            <v-form @submit.prevent v-else>
              <template v-if="mode === 'login'">
                <v-text-field
                  v-model="email"
                  :label="$t('email')"
                  name="email"
                  type="email"
                  outlined
                  dense
                  prepend-inner-icon="email"
                ></v-text-field>
                <v-text-field
                  v-model="password"
                  :label="$t('password')"
                  name="password"
                  type="password"
                  @keypress.enter="login"
                  outlined
                  dense
                  prepend-inner-icon="lock_outline"
                ></v-text-field>
                <div class="text-right mt-n6">
                  <v-btn text color="grey" to="/forgot">{{
                    $t('login.forgotPassword')
                  }}</v-btn>
                </div>
                <div class="text-center mt-6">
                  <v-btn
                    class="d-block col-12"
                    color="primary"
                    depressed
                    large
                    @click="login"
                    :disabled="loading"
                    >{{ $t('login.enter') }}</v-btn
                  >
                </div>
                <div class="text-center mt-4">
                  <v-btn text color="grey" @click="setMode('signup')">{{
                    $t('login.dontHaveAccount')
                  }}</v-btn>
                </div>
              </template>
              <template v-else>
                <v-form @submit.prevent v-model="valid">
                  <v-text-field
                    v-model="name"
                    :rules="$rule('required')"
                    :label="$t('name')"
                    outlined
                    dense
                    prepend-inner-icon="face"
                  ></v-text-field>
                  <v-text-field
                    v-model="email"
                    :rules="$rule('required|email')"
                    :label="$t('email')"
                    type="email"
                    outlined
                    dense
                    prepend-inner-icon="email"
                  ></v-text-field>
                  <v-text-field
                    v-model="rEmail"
                    :rules="[
                      (v) => v === email || $t('signup.emailsDontMatch'),
                    ]"
                    :label="$t('signup.repeatEmail')"
                    type="email"
                    outlined
                    dense
                    prepend-inner-icon="mdi-email-outline"
                  ></v-text-field>
                  <v-text-field
                    v-model="password"
                    :rules="$rule('required|min6|max64')"
                    :label="$t('password')"
                    type="password"
                    outlined
                    dense
                    prepend-inner-icon="lock"
                  ></v-text-field>
                  <v-text-field
                    v-model="rPassword"
                    :rules="[
                      (v) => v === password || $t('signup.passwordsDontMatch'),
                    ]"
                    @keypress.enter="signup"
                    :label="$t('signup.repeatPassword')"
                    type="password"
                    outlined
                    dense
                    prepend-inner-icon="lock_outline"
                  ></v-text-field>
                  <div class="text-center mt-6">
                    <v-btn
                      class="d-block col-12"
                      color="primary"
                      depressed
                      large
                      @click="signup"
                      :disabled="loading || !valid"
                      >{{ $t('create') }}</v-btn
                    >
                  </div>
                  <div class="text-center mt-4">
                    <v-btn text color="grey" @click="setMode('login')">{{
                      $t('signup.alreadyHaveAccount')
                    }}</v-btn>
                  </div>
                </v-form @submit.prevent>
              </template>
            </v-form @submit.prevent>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts">
  import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
  import UsersService from '../../api/services/users.service';
  import { vueData } from '../../VueData';
  import { AlertType } from '../../interfaces/IAlert';
  import AuthService from '../../api/services/auth.service';
  import { Globals } from '../../modules/Globals';
  import ILocationData from '../../interfaces/ILocationData';

  @Component
  export default class LoginPage extends Vue {
    @Prop() country: string;
    mode: 'login' | 'signup' = 'login';
    name: string = '';
    email: string = '';
    password: string = '';
    rPassword: string = '';
    rEmail: string = '';
    usersService: UsersService = new UsersService();
    authService: AuthService = new AuthService();
    loading: boolean = false;
    valid = false;
    newUser = false;
    partnerToken = null;
    cookiesEnabled = Globals.cookiesEnabled();

    async created() {
      if (this.$route.query.tab) {
        this.mode = this.$route.query.tab as 'login' | 'signup';
      }
    }

    mounted() {
      let token;

      if (this.$route.query.pid) {
        token = this.$route.query.pid;
        if (Globals.hasLocalStorage()) {
          localStorage.setItem('pid', token);
        }
      } else if (Globals.hasLocalStorage()) {
        token = localStorage.getItem('pid');
      }

      this.partnerToken = token;
    }

    setMode(mode: 'login' | 'signup') {
      this.mode = mode;
      this.password = '';
      this.rPassword = '';
      this.rEmail = '';
      this.$router.replace({ query: { tab: this.mode } });
    }

    async login() {
      this.loading = true;

      try {
        let user = await this.authService.login(this.email, this.password);
        vueData.addAlert(this.$tc('welcome'), AlertType.Success);
        vueData.setUser(user);
        this.$gtag.event('login');
        this.$router.push(
          this.$route.query.hasOwnProperty('redirect') &&
            (<string>this.$route.query.redirect).trim() !== '/'
            ? <string>this.$route.query.redirect
            : this.newUser
            ? '/new'
            : '/dashboard'
        );
      } catch (e) {
        console.error(e);
        vueData.serverError(e, this.$tc('login.error'));
      } finally {
        this.loading = false;
      }
    }

    async signup() {
      if (!this.name) {
        vueData.addAlert('Ingrese un nombre', AlertType.Error);
        return;
      }
      if (this.email !== this.rEmail) {
        vueData.addAlert(this.$tc('signup.emailsDontMatch'), AlertType.Error);
        return;
      }
      if (this.password !== this.rPassword) {
        vueData.addAlert(
          this.$tc('signup.passwordsDontMatch'),
          AlertType.Error
        );
        return;
      }

      this.loading = true;
      try {
        let user = await this.usersService.create({
          name: this.name,
          email: this.email,
          password: this.password,
          partnerToken: this.partnerToken,
        });
        this.$gtag.event('signup');
        try {
          vueData.conversion(
            '1036472587',
            '8jwoCMKos9UBEIuine4D',
            'Crear cuenta'
          );
        } catch (e) {
          console.error('analytics failed');
        }

        if (this.partnerToken && Globals.hasLocalStorage()) {
          localStorage.removeItem('pid');
        }

        this.newUser = true;
        await this.login();
      } catch (e) {
        console.error(e);
        vueData.serverError(e, this.$tc('signup.error'));
      } finally {
        this.loading = false;
      }
    }
  }
</script>
